import { faUserAstronaut } from '@fortawesome/pro-regular-svg-icons/faUserAstronaut';
import { faRocket } from '@fortawesome/pro-regular-svg-icons/faRocket';

export const USER_TYPE = 'personal';
export const B2B_TYPE = 'empresas';
export const COOKIE_TAB = 'price-tab';

export const tabsData = [
  {
    id: 1,
    text: USER_TYPE,
    icon: faUserAstronaut,
  },
  {
    id: 2,
    text: B2B_TYPE,
    icon: faRocket,
  },
];
